import { VA_FORM_IDS } from 'platform/forms/constants';
import {
  ITF_FETCH_SUCCEEDED,
  ITF_FETCH_FAILED,
  ITF_CREATION_SUCCEEDED,
  ITF_CREATION_FAILED,
} from './actions';

const analyticsEvents = [
  {
    action: ITF_CREATION_SUCCEEDED,
    event: 'disability-526EZ-itf-created',
  },
  {
    action: ITF_CREATION_FAILED,
    event: 'disability-526EZ-itf-not-created',
  },
  {
    action: ITF_FETCH_SUCCEEDED,
    event: 'disability-526EZ-itf-retrieved',
  },
  {
    action: ITF_FETCH_FAILED,
    event: store => {
      const { savedForms } = store.getState().user.profile;
      const hasV2 = savedForms.some(
        f => f.form === VA_FORM_IDS.FORM_21_526EZ_V2,
      );
      const hasV1 = savedForms.some(f => f.form === VA_FORM_IDS.FORM_21_526EZ);
      // Keep the event name stable for existing dashboards, but add a
      // formVersion dimension (v2 takes precedence when both exist) so v1 vs v2
      // ITF-fetch failures can be monitored separately.
      let formVersion = 'none';
      if (hasV2) {
        formVersion = 'v2';
      } else if (hasV1) {
        formVersion = 'v1';
      }
      return {
        event:
          hasV1 || hasV2
            ? 'disability-526EZ-itf-not-retrieved-saved-form-found'
            : 'disability-526EZ-itf-not-retrieved-saved-form-not-found',
        formVersion,
      };
    },
  },
];

export default analyticsEvents;
